import { useContext, useState, useMemo } from "react";
import { Box, TextField, InputAdornment } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { ActivitiesContext } from "../../context/activities/ActivitiesContext";
import ActivityCard from "./ActivityCard";

const ActivitiesList = () => {
  const { activities } = useContext(ActivitiesContext);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredActivities = useMemo(() => {
    if (!searchTerm.trim()) {
      return activities;
    }
    const lowerSearch = searchTerm.toLowerCase();
    return activities.filter(
      (activity) =>
        activity.name?.toLowerCase().includes(lowerSearch) ||
        activity.description?.toLowerCase().includes(lowerSearch),
    );
  }, [activities, searchTerm]);

  return (
    <Box className="activities-page__list-container">
      <TextField
        placeholder="Search activities..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        size="small"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "text.secondary" }} />
            </InputAdornment>
          ),
        }}
        sx={{ mb: 2 }}
      />
      <Box className="activities-page__list scroller">
        {filteredActivities.map((activity) => (
          <ActivityCard key={activity.activityId} activity={activity} />
        ))}
      </Box>
    </Box>
  );
};

export default ActivitiesList;
